"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _gaugeCardCheckbox = _interopRequireDefault(require("./gaugeCardCheckbox.js"));
require("./gauge.css");
var _jsxRuntime = require("react/jsx-runtime");
const GaugeCard = props => {
  const {
    gaugeData,
    handleChecked,
    checkedItem
  } = props;
  const renderOptions = gaugeData => {
    return gaugeData.map(item => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gaugeCardCheckbox.default, {
        isChecked: checkedItem === item.value,
        item: item,
        handleChecked: handleChecked
      });
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: renderOptions(gaugeData)
  });
};
var _default = exports.default = GaugeCard;
module.exports = exports.default;
module.exports.default = exports.default;